module.exports = __webpack_public_path__ + "img/roundedCheckIcon.5897d915.svg";